import type { SubscriptionPlan } from '@/types/billing.types'

export function getBankBadgeText(maxBankAccounts: number): string {
  if (maxBankAccounts === 1) {
    return '1 BANCO INTEGRADO'
  } else if (maxBankAccounts === -1) {
    return 'BANCOS ILIMITADOS'
  } else {
    return `ATÉ ${maxBankAccounts} BANCOS INTEGRADOS`
  }
}

export function getPlanFeatures(plan: SubscriptionPlan): string[] {
  const features: string[] = []

  features.push('Acesso a TODOS os módulos e relatórios')
  features.push('App mobile no celular')
  features.push('Painel único para gerenciar suas empresas*')

  const planName = (plan.name || '').toLowerCase()
  if (planName.includes('scale')) {
    features.push('Suporte prioritário')
  } else if (planName.includes('enterprise')) {
    features.push('Atendimento dedicado')
  }

  return features;
}
